import * as React from 'react';
import NewSettingPopup from '../common/NewSettingPopup';
import ReflowableContentSNEUserPatternSetting from './ReflowableContentSNEUserPatternSetting';
import { DialogType } from '../common/SettingDialogContainer';

interface ReflowableContentSNEColorSettingDialogProps {
  onClose: () => void;
  readonly setDialogType: (dialogType: DialogType) => void;
}

const ReflowableContentSNEColorSettingDialog: React.SFC<
  ReflowableContentSNEColorSettingDialogProps
> = React.memo((props) => {
  const { onClose } = props;
  return (
    <NewSettingPopup imgName="text_color_select" title="色選択" onClose={onClose}>
      <ReflowableContentSNEUserPatternSetting
        onBackButtonClick={
          () => { props.setDialogType(DialogType.ReflowableContent); }
        }
      />
    </NewSettingPopup>
  );
});

export default ReflowableContentSNEColorSettingDialog;
